export const providerKeyEnum = {
  airbnb: 'airbnb',
  vrbo: 'vrbo',
  manual: 'manual',
} as const

export type ProviderKeyValues = (typeof providerKeyEnum)[keyof typeof providerKeyEnum]

export const providerLabelMap = {
  [providerKeyEnum.airbnb]: 'Airbnb',
  [providerKeyEnum.vrbo]: 'Vrbo',
  [providerKeyEnum.manual]: 'Manual',
}

export const statusKeyEnum = {
  booked: 'booked',
  in_progress: 'in_progress',
  canceled: 'canceled',
  completed: 'completed',
} as const

export type StatusKeyValues = (typeof statusKeyEnum)[keyof typeof statusKeyEnum]

export const statusLabelMap = {
  [statusKeyEnum.booked]: 'Booked',
  [statusKeyEnum.in_progress]: 'In Progress',
  [statusKeyEnum.canceled]: 'Canceled',
  [statusKeyEnum.completed]: 'Completed',
}

export const reservationKindEnum = {
  reservation: 'reservation',
  block: 'block',
} as const

export type ReservationKindValues = (typeof reservationKindEnum)[keyof typeof reservationKindEnum]

// Booking details TRA/SIRE need; calendar sync never imports them.
export const bookingDetailEnum = {
  missingPrice: 'missing_price',
  missingGuestCount: 'missing_guest_count',
} as const

export type BookingDetailValues = (typeof bookingDetailEnum)[keyof typeof bookingDetailEnum]
